//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[[0,"Id",0,0],[0,"Label",0,0]],[[[],"GetRgb",{R_:{rgb:''}},0,0]],[]];
SPLM.NXColor = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.NXColor";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.NXColor.Rgb = class{
    constructor(r,g,b){
        this.r=r;this.g=g;this.b=b;}
    get R(){return this.r}
    set R(val){this.r = val}
    get G(){return this.g}
    set G(val){this.g = val}
    get B(){return this.b}
    set B(val){this.b = val}
};

export default SPLM;